module.exports = __webpack_public_path__ + "media/images/emoticons/search-ec029ff09c4fd2495171f7dae4dc2051.gif";